@if (label) {
  <div class="pr-input-container">
    <pr-input-abstract
      [control]="control"
      [derrors]="derrors"
      class="pr-input-checkbox-group"
    >
      <span class="pr-input-label"
        >{{ label }}
        @if (
          required ||
          (control &&
            control.validator &&
            control.validator({}) &&
            control.validator({}).required)
        ) {
          <em> <span>&#160;</span>*</em>
        }
      </span>
      <span
        class="pr-input-container-control"
        [ngClass]="{
          'is-invalid': derrors && control?.errors,
          readonly: readonly,
        }"
      >
        <ng-content></ng-content>
        <pr-errors [derrors]="derrors" [control]="control"></pr-errors>
      </span>
    </pr-input-abstract>
  </div>
}
@for (option of options; track option) {
  <checkbox
    [template]="template"
    [value]="option.value"
    (change)="onItemChange($event, option.value)"
    [label]="option.label"
    [maxSelected]="maxSelected"
    [disabled]="option?.disabled || false"
  >
  </checkbox>
  <ng-template #default></ng-template>
  <ng-container
    [ngTemplateOutlet]="template || default"
    [ngTemplateOutletContext]="{ $implicit: option, index: i }"
  >
  </ng-container>
}
